export default [
  {
    id: 1,
    label: "Mapbox Basic",
    name: "basic"
  },
  {
    id: 2,
    label: "Mapbox Streets",
    name: "streets"
  },
  {
    id: 3,
    label: "Mapbox Bright",
    name: "bright"
  },
  {
    id: 4,
    label: "Mapbox Light",
    name: "light"
  },
  {
    id: 5,
    label: "Mapbox Dark",
    name: "dark"
  }
];
